<template>
  <div class='addEvent container mt-5 mb-5'>
    <h1>Add Event</h1>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-form-group id="name-group" label="Your Name *" label-for="name">
        <b-form-input
          id="name"
          v-model="form.name"
          required
          placeholder="Name"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="email-group"
        label="Your Contact Email *"
        label-for="email"
      >
        <b-form-input
          id="email"
          v-model="form.email"
          type="email"
          required
          placeholder="Email"
        ></b-form-input>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox
          id="display-contact"
          v-model="form.displayContact"
          name="display-contact"
          value="show"
          unchecked-value="hide"
        >
          Show my contact info with the event listing
        </b-form-checkbox>
      </b-form-group>

      <b-form-group
        id="notes-group"
        label="Private notes for the calendar owner"
        label-for="notes"
      >
        <b-form-textarea
          id="notes"
          v-model="form.privateNotes"
          type="text"
          placeholder="Notes"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group id="title-group" label="Event Title *" label-for="title">
        <b-form-input
          id="title"
          v-model="form.title"
          required
          placeholder="Event Title"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="location-group" label="Location" label-for="location">
        <b-form-input
          id="location"
          v-model="form.location"
          placeholder="Location"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="link-group" label="Event Link" label-for="link" description="You may enter a URL for more details about the event (ex. https://scouting.org)">
        <b-form-input
          id="link"
          v-model="form.link"
          placeholder="Event Link"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="start-date-group" label="Start Date *" label-for="start-date">
        <b-form-datepicker id="start-date" v-model="form.startDate" required></b-form-datepicker>
      </b-form-group>

      <b-form-group id="start-time-group" label="Start Time" label-for="start-time">
        <b-form-timepicker id="start-time" v-model="form.startTime" locale="en"></b-form-timepicker>
      </b-form-group>

      <b-form-group id="end-date-group" label="End Date *" label-for="end-date">
        <b-form-datepicker id="end-date" v-model="form.endDate" required></b-form-datepicker>
      </b-form-group>

      <b-form-group id="end-time-group" label="End Time" label-for="end-time">
        <b-form-timepicker id="end-time" v-model="form.endTime" locale="en"></b-form-timepicker>
      </b-form-group>

      <b-form-group
        id="description-group"
        label="Event Description"
        label-for="description"
      >
        <b-form-textarea
          id="description"
          v-model="form.description"
          type="text"
          placeholder="Event Description"
        ></b-form-textarea>
      </b-form-group>

      <b-button type="submit" variant="primary" class="mr-2">Submit</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
    <b-alert v-model="showSuccess" variant="success">
      Event successfully submitted for approval!
    </b-alert>
    <b-alert v-model="showError" variant="danger" dismissible>
      Error submitting event!
    </b-alert>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  components: {
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        displayContact: '',
        privateNotes: '',
        title: '',
        location: '',
        link: '',
        startDate: null,
        startTime: '00:00:00',
        endDate: null,
        endTime: '00:00:00',
        description: '',
      },
      show: true,
      showError: false,
      showSuccess: false,
    };
  },
  mounted() {},
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      const database = firebase.firestore();
      database.collection('calendars').doc(this.$route.params.calendar).collection('events').add({
        name: this.form.name,
        email: this.form.email,
        notes: this.form.privateNotes,
        title: this.form.title,
        location: this.form.location,
        link: this.form.link,
        start: firebase.firestore.Timestamp.fromDate(
          new Date(`${this.form.startDate}T${this.form.startTime}-05:00`),
        ),
        end: firebase.firestore.Timestamp.fromDate(
          new Date(`${this.form.endDate}T${this.form.endTime}-05:00`),
        ),
        description: this.form.description,
      })
        .then(() => {
          this.showSuccess = true;
          this.showError = false;
        })
        .catch((error) => {
          this.showSuccess = false;
          this.showError = true;
          console.log('Error submitting event: ', error);
        });
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = '';
      this.form.name = '';
      this.form.privateNotes = '';
      this.form.title = '';
      this.form.location = '';
      this.form.description = '';
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};

</script>

<style lang='scss'>

</style>
